import * as ActionTypes from "../ActionTypes.js";

export const authReducer = (
  state = {
    isAuthenticated: localStorage.getItem("creds") ? true : false,
    user: localStorage.getItem("creds")
      ? JSON.parse(localStorage.getItem("creds"))
      : null,
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.LOGIN_USER:
      return { ...state, isAuthenticated: true, user: action.payload };
    case ActionTypes.LOGOUT_USER:
      return { ...state, isAuthenticated: false, user: null };
    default:
      return state;
  }
};
